import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
var AlertModalService = /** @class */ (function () {
    function AlertModalService() {
        this._subject = new Subject();
        this._reloadSubject = new Subject();
    }
    AlertModalService.prototype.open = function (params, error, initEvent) {
        this._subject.next({ params: params, error: error, initEvent: initEvent });
    };
    Object.defineProperty(AlertModalService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AlertModalService.prototype.reload = function () {
        this._reloadSubject.next();
    };
    Object.defineProperty(AlertModalService.prototype, "reloadObservable", {
        get: function () {
            return this._reloadSubject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    AlertModalService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AlertModalService.ctorParameters = function () { return []; };
    return AlertModalService;
}());
export { AlertModalService };
var Modal = /** @class */ (function () {
    function Modal() {
    }
    return Modal;
}());
export { Modal };
var ModalButton = /** @class */ (function () {
    function ModalButton() {
    }
    return ModalButton;
}());
export { ModalButton };
//# sourceMappingURL=alertmodal.service.js.map